<div class="columns">
  <div class="column">
    @if (isActive) {
      <app-header
        header="kws.title"
        subHeader="kws.subtitle"
        class="mb-5"
      ></app-header>
    }
  </div>
  @if (hasLinkToImprint() || (isActive && isAtruvia)) {
    <div
      class="column is-flex is-justify-content-flex-end is-align-items-center activate-switch"
    >
      <app-activate-product-switch
        [isActive]="isActive"
        (onActiveChanged)="toggleActiveState($event)"
      ></app-activate-product-switch>
    </div>
  }
</div>

@if (!isActive) {
  <div class="mb-4 mx-2">
    <app-action-box
      class="mb-4"
      header="serviceDisabled.title"
      subHeader="kws.disabled.subtitle"
      icon="Earth Remove"
      iconClass="tile-icon has-text-danger has-background-danger-light"
      isNotClickable
      [isFullheight]="false"
      hideCtaButton
    >
      @if (!hasLinkToImprint()) {
        <div
          class="notification is-danger is-light is-flex is-flex-direction-column is-align-items-center"
        >
          <p translate="kws.disabled.setLink.info"></p>

          <button
            [primary]="true"
            type="button"
            (click)="openImprintModal()"
            fino-button
            label="kws.disabled.setLink.button"
          ></button>
        </div>
      }
    </app-action-box>
  </div>
}

<div class="fixed-grid">
  <div class="grid is-gap-2">
    <div class="cell">
      @if (kwsSettings) {
        <app-action-box
          class="mb-4 is-flex"
          header="kws.basicInfo.info.title"
          subHeader="kws.basicInfo.info.subtitle"
          iconSrc="/assets/icons/icon-info.svg"
          iconClass="p-4"
          isNotClickable
          hideCtaButton
        >
          <div class="p-4">
            <app-basic-info
              [links]="kwsSettings.links"
              [hasNachlass]="hasNachlass()"
              [dns]="dns()"
              [isAtruvia]="isAtruvia"
            ></app-basic-info>
          </div>

          <div class="is-fullwidth is-flex is-justify-content-center mt-4">
            <button
              [primary]="true"
              type="button"
              (click)="openDashboard()"
              fino-button
              label="kws.basicInfo.dashboard"
            ></button>
          </div>
        </app-action-box>
      }
      <app-action-box
        (click)="openSustainabilityModa()"
        class="is-flex"
        header="kws.actions.nachhaltigkeit.title"
        [active]="featurePaperSaved"
        subHeader="kws.actions.nachhaltigkeit.subtitle"
        icon="Renewable Energy Earth"
      ></app-action-box>
    </div>
    <div class="cell is-flex is-flex-direction-column">
      <app-action-box
        (click)="openImprintModal()"
        class="is-flex mb-4 is-flex-grow-1"
        header="kws.actions.bankinfo.title"
        subHeader="kws.actions.bankinfo.subtitle"
        icon="Official Building 3"
      ></app-action-box>

      <app-action-box
        (click)="openLegalModal()"
        class="is-flex is-flex-grow-1"
        header="kws.actions.privacy.title"
        subHeader="kws.actions.privacy.subtitle"
        icon="Legal Hammer"
      ></app-action-box>

      @if (isCockpitEnabled) {
        <app-action-box
          (click)="openCockpit()"
          class="is-flex is-flex-grow-1 mt-4"
          header="kws.actions.cockpit.title"
          subHeader="kws.actions.cockpit.subtitle"
          ctaLabel="kws.actions.cockpit.cta"
          icon="Network Arrow"
        ></app-action-box>
      }
    </div>
  </div>
</div>
